const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/rke/v1frontend/rke-unlock/create', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
